import React, { Component } from 'react';


class PageNotFound extends Component {

    render() {
        return (
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-header">Page not Found</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PageNotFound;
